import { Entity } from "../../../entity.js";
export class InstructionsScreenRender extends Entity {
    constructor(canvasWidth, canvasHeight) {
        super();
        this.canvasWidth = canvasWidth;
        this.canvasHeight = canvasHeight;
        super.setRenderer(new Renderer(canvasWidth, canvasHeight));
    }
}
class Renderer {
    constructor(canvasWidth, canvasHeight) {
        this.canvasWidth = canvasWidth;
        this.canvasHeight = canvasHeight;
    }
    draw(context) {
        const ctx = context.ctx;
        ctx.save();
        // Set text styling
        ctx.fillStyle = "white";
        ctx.textAlign = "center";
        // Title
        ctx.font = "bold 98px 'Jersey-20', monospace";
        ctx.fillText("HOW TO PLAY", this.canvasWidth / 2, (this.canvasHeight / 2) - 225);
        // Instructions body
        ctx.font = "32px 'Jersey-20', monospace";
        const lineHeight = 30;
        let yOffset = (this.canvasHeight / 2) - 70;
        // Game instructions
        const instructions = [
            "WASD to Move",
            "E to Pick Up Items",
            "Q to Drop Items",
            "F to Deliver Items",
            "Collect Items on time,",
            "avoiding the lost husks",
            "who seek your soul!",
            "",
            "Good luck, runner!"
        ];
        instructions.forEach((line) => {
            ctx.fillText(line, this.canvasWidth / 3, yOffset);
            yOffset += lineHeight;
        });
        //reset
        yOffset = (this.canvasHeight / 2) - 70;
        const lore = [
            "Living in the year 2167,",
            "You are tredging through by working for",
            "a megaconglomerate with advanced",
            "technology to transport your soul",
            "into an expendible husk.",
            "",
            "Be wary, young traveler. May you",
            "return from this experience alive."
        ];
        lore.forEach((line) => {
            ctx.fillText(line, this.canvasWidth - (this.canvasWidth / 3), yOffset);
            yOffset += lineHeight;
        });
        //reset
        yOffset = (this.canvasHeight / 2) - 70;
        ctx.restore();
    }
}
